/**
 * Created by JackCui on 2022/2/21
 */

import {customDataModelHandle, dataModelHandle} from '../../utils/page-driven/utils/data-handle'
import parsingRules from '../../utils/page-driven'

export default {
  methods: {
    _initPageRules (pageRule) {
      // code 改版 兼容数据
      if (!pageRule) {
        return
      }
      const apiPageRules = dataModelHandle(pageRule)
      const pageDriven = customDataModelHandle(this.pageRules).concat(apiPageRules)
      const varMap = {[this.objectApiName]: this.formData}
      // 为每个相关组件绑定事件
      parsingRules.call(this, {
        pageDriven,
        varMap,
        dispatch: this._dispatch
      })
    },
    _dispatch ({eventType, objectApiName, statusParam: {apiName, flag}}) {
      const checkError = (obj, objectApiName, apiName) => {
        if (!obj?.[objectApiName]?.[apiName]) {
          console.error(`Invalid:eventType:'${eventType}' objectApiName:'${objectApiName}' apiName:'${apiName}'`)
        }
      }
      const setField = (key, flag) => {
        try {
          this.fieldMap[objectApiName] && this.fieldMap[objectApiName][apiName] && this.$set(this.fieldMap[objectApiName][apiName].props, key, flag)
        } catch (error) {
          checkError(this.fieldMap, objectApiName, apiName)
        }
      }
      const eventMap = {
        'fieldShow': () => setField('pageShow', flag),
        'fieldRequired': () => setField('required', flag),
        'fieldReadOnly': () => setField('disabled', flag),
        'fieldLabel': () => setField('hideLabel', flag),
        'fieldPlainText': () => setField('isPureText', flag),
        'buttonHide': () => {
          checkError(this.buttonMap, objectApiName, apiName)
          this.buttonMap[objectApiName]?.[apiName] && this.$set(this.buttonMap[objectApiName][apiName], 'hide', flag)
        },
        'columnHide': () => {
          checkError(this.columnMap, objectApiName, apiName)
          this.columnMap[objectApiName]?.[apiName] && this.$set(this.columnMap[objectApiName][apiName], 'hide', flag)
        },
        'columnShow': () => {
          checkError(this.columnMap, objectApiName, apiName)
          this.columnMap[objectApiName]?.[apiName] && this.$set(this.columnMap[objectApiName][apiName], 'hide', !flag)
        }
      }
      eventMap[eventType] && eventMap[eventType]()
    },
    fieldShow (objectApiName, apiName, flag) {
      this._dispatch({
        eventType: 'fieldShow',
        objectApiName,
        statusParam: {
          apiName,
          flag
        }
      })
    },
    fieldRequired (objectApiName, apiName, flag) {
      this._dispatch({
        eventType: 'fieldRequired',
        objectApiName,
        statusParam: {
          apiName,
          flag
        }
      })
    },
    fieldReadOnly (objectApiName, apiName, flag) {
      this._dispatch({
        eventType: 'fieldReadOnly',
        objectApiName,
        statusParam: {
          apiName,
          flag
        }
      })
    },
    fieldLabel (objectApiName, apiName, flag) {
      this._dispatch({
        eventType: 'fieldLabel',
        objectApiName,
        statusParam: {
          apiName,
          flag
        }
      })
    },
    fieldPlainText (objectApiName, apiName, flag) {
      this._dispatch({
        eventType: 'fieldPlainText',
        objectApiName,
        statusParam: {
          apiName,
          flag
        }
      })
    },
    buttonHide (objectApiName, apiName, flag) {
      this._dispatch({
        eventType: 'buttonHide',
        objectApiName,
        statusParam: {
          apiName,
          flag
        }
      })
    },
    columnHide (objectApiName, apiName, flag) {
      this._dispatch({
        eventType: 'columnHide',
        objectApiName,
        statusParam: {
          apiName,
          flag
        }
      })
    }
  }
}
